// extracted by mini-css-extract-plugin
export default {"loader":"PastBookings_loader__BcXfw","h1":"PastBookings_h1__5+KCS","wishlist":"PastBookings_wishlist__KuygV","wishlist1":"PastBookings_wishlist1__tj5YK"};